import React, { useEffect, useState } from "react";
import styles from "./CountrySelect.module.scss";
import { Select } from "../Select/Select";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import { hasFlag } from "country-flag-icons";
import clsx from "clsx";
import { ValidationInputState } from "../../ValidationInputState";

interface CountrySelectComponentProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconComponent?: any;

  className?: string;
  disabled?: boolean;
  name?: string;
  onBlur?: () => void;
  onChange?: (value?: string) => void;
  onFocus?: () => void;
  /**
   * The list of all selectable countries (including "International")
   */
  options?: Array<{ value?: string; label: string; icon: React.Component }>;
  tabIndex?: number;
  /**
   * The currently selected country code
   */
  value?: string;
  /**
   * Language translations
   */
  labels?: { [key: string]: string };

  validationState?: ValidationInputState;
}

const CountrySelect: React.ForwardRefRenderFunction<
  HTMLSelectElement,
  CountrySelectComponentProps
> = (props, ref) => {
  const {
    options,
    onChange,
    value, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    iconComponent,
    ...selectProps
  } = props;

  const icon = value && hasFlag(value) ? getUnicodeFlagIcon(value) : undefined;
  const [countryCallingCode, setCountryCallingCode] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    const loadCountryCallingCode = async () => {
      const { getCountryCallingCode } = await import(
        "react-phone-number-input/min"
      );

      try {
        setCountryCallingCode(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          value ? (getCountryCallingCode(value as any) as string) : undefined
        );
      } catch (_e) {
        setCountryCallingCode(undefined);
      }
    };
    loadCountryCallingCode();
  }, [value]);

  return (
    <div className={styles.wrapper}>
      <Select
        ref={ref}
        {...selectProps}
        value={value}
        className={styles.select}
        dataContentPiece="select_phone_country"
        onChange={(e) => {
          if (onChange) onChange(e.target.value);
        }}
      >
        {options?.map((o) => (
          <option key={o.label} value={o.value}>
            {o.label}
          </option>
        ))}
      </Select>
      <div
        className={clsx(styles.selectedCountry, {
          [styles.disabled]: selectProps.disabled,
          [styles.stateInvalid]: selectProps.validationState == "error"
        })}
      >
        {icon && <span className={styles.icon}>{icon}</span>}{" "}
        {countryCallingCode && `+${countryCallingCode}`}
      </div>
    </div>
  );
};

export default React.forwardRef(CountrySelect);
